<template>
	<div>
		<Echart
		  :options="options"
		  id="toprightchartaq"
		  height="350px"
		  width="100%"
		></Echart>
	</div>
</template>

<script>
import Echart from '@/common/echart' // eslint-disable-line no-unused-vars
export default {
	data () {
	  return {
		  options:{
			 legend: {
			     top: 'top'
			   },
			   toolbox: {
			     show: false,
			     feature: {
			       mark: { show: true },
			       dataView: { show: true, readOnly: false },
			       restore: { show: true },
			       saveAsImage: { show: true }
			     }
			   },
			   
			   series: [
			     {
			       name: '',
			       type: 'pie',
			       radius: [40, 80],
			       center: ['50%', '60%'],
			       roseType: 'area',
			       itemStyle: {
			         borderRadius: 10
			       },
				   label: {
				                   normal: {
				                       show: true,
				                       formatter: '{b}:{c}人'
				                   }
				               },
			       data: [
			         { value: 7685, name: '兴安街道' },
			         { value: 5676, name: '新安街道' },
			         { value: 5047, name: '凌河街道' },
			         { value: 321, name: '景芝镇' },
			         { value: 2754, name: '官庄镇' },
			         { value: 352, name: '大盛镇' },
			         { value: 323, name: '石埠子镇' },
			         { value: 251, name: '石堆镇' },
					 { value: 2754, name: '拓山镇' },
					 { value: 352, name: '辉渠镇' },
					 { value: 654, name: '吾山镇' },
					 { value: 2135, name: '金冢子镇' }
			       ],
			     }
			   ]
		  }
	  }
	},
	components: {
	  Echart
	},
}
</script>

<style></style>
